import SpacePath from "components/SpacePath";
import { SpacesContext } from "views/Account/SpacesProvider";
import useTypedContext from "hooks/useTypedContext";

import { CellComponentProps } from "../types";

type RoleUsedByListItemSpaceCellProps = CellComponentProps;

const RoleUsedByListItemSpaceCell = ({ entity }: RoleUsedByListItemSpaceCellProps) => {
  const { spaces } = useTypedContext(SpacesContext);
  const hasAccessToSpace = !!spaces.find(({ id }) => id === entity.space.id);

  return (
    <SpacePath
      spaceId={entity.space.id}
      fallbackName={entity.space.name}
      disabled={!hasAccessToSpace}
      tooltip={!hasAccessToSpace ? "You don't have access to this space" : undefined}
    />
  );
};

export default RoleUsedByListItemSpaceCell;
